import { Box } from '@mui/material';
import React, { useContext } from 'react';
import { JustifyStartRow } from 'spw-shared/globalComponents/grid';
import { numberWithCommasOrDash } from 'spw-shared/utils';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import { useCardIcon } from 'spw-esa-projects/program-summary/cards/hooks';
import { ProgramSummaryCardType } from 'spw-esa-projects/program-summary/icon-selector-popover';
import CardIcon from 'spw-esa-projects/program-summary/card-icon';
import { ProgrammingSummaryCardsContext } from '../program-summary-tabs/summary-card-context';
import {
  CardTitle,
  BigValuePair,
  BigValue,
  BigKey,
  IconWrapper,
} from './styles';

export const HeadcountUsf = ({
  showRsf,
  totalProgramUSF,
  totalProgramRSF,
  futureHeadcount,
}: {
  showRsf: boolean;
  totalProgramUSF: number;
  totalProgramRSF: number;
  futureHeadcount: number;
}) => {
  const { getUnit, convertToUnit } = useUnitConversion();

  const cardIcon = useCardIcon(ProgramSummaryCardType.headcountUsf);
  const { selectedCardIcon, onClickCardIcon } = useContext(
    ProgrammingSummaryCardsContext
  );

  const handleIconClick = (event: React.MouseEvent<HTMLDivElement>) => {
    onClickCardIcon(event, cardIcon);
  };

  const isIconCardSelected =
    selectedCardIcon?.cardType === ProgramSummaryCardType.headcountUsf;

  const headcountUsf = Math.round(
    (convertToUnit(totalProgramUSF, { unitType: 'area' }) as number) /
      futureHeadcount
  );
  const headcountRsf = Math.round(
    (convertToUnit(totalProgramRSF, { unitType: 'area' }) as number) /
      futureHeadcount
  );

  return (
    <Box>
      <CardTitle data-testid="programming_ps_headcount_usf_title">
        HEADCOUNT{' '}
        {showRsf
          ? `${getUnit('area')} + ${getUnit('rentable-area')}`
          : getUnit('area')}
      </CardTitle>
      <JustifyStartRow style={{ height: '72px' }}>
        <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
          <BigValuePair style={{ flexGrow: 1 }} className="no-padding">
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <IconWrapper style={{ maxWidth: 32 }}>
                <CardIcon
                  iconPath={`/images/space-icons/${cardIcon.iconPath}`}
                  onClick={handleIconClick}
                  height={32}
                  width={32}
                  containerHeight={32}
                  isSelected={isIconCardSelected}
                />
              </IconWrapper>
              <Box>
                <BigValue data-testid="programming_ps_headcount_usf_programUSFOverFutureHeadcount">
                  {numberWithCommasOrDash(headcountUsf)}
                </BigValue>

                <BigKey>
                  Program {getUnit('area')} /<br />
                  Headcount
                </BigKey>
              </Box>
            </div>
          </BigValuePair>
          {showRsf && (
            <BigValuePair style={{ flexGrow: 1 }} className="no-padding">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  alignItems: 'center',

                  flex: 1,
                  width: '100%',
                }}
              >
                <IconWrapper style={{ maxWidth: 32 }}>
                  <CardIcon
                    iconPath={`/images/space-icons/${cardIcon.iconPath}`}
                    onClick={handleIconClick}
                    height={32}
                    width={32}
                    containerHeight={32}
                    isSelected={isIconCardSelected}
                  />
                </IconWrapper>
                <Box>
                  <BigKey>
                    <BigValue>{numberWithCommasOrDash(headcountRsf)}</BigValue>
                    Program {getUnit('rentable-area')} /<br />
                    Headcount
                  </BigKey>
                </Box>
              </div>
            </BigValuePair>
          )}
        </div>
      </JustifyStartRow>
    </Box>
  );
};
